import styles from "./index.module.scss";
import { 
  ExpTempList,
  SourceImgUploader,
  Result,
  GenerateButton,
  SourceImg,
  MainOperation,
  SampleVideo,
} from "@/components";
import { useCommonStore } from "@/stores";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { TaskStatus } from "@/constants";
import { Suspense, lazy } from "react";

const RemoveTip = lazy(() => import("@/components/remove-tip"));
const Generating = lazy(() => import("@/components/generating"));

const Main = () => {
  const sourceImgBlobUrl = useCommonStore(state => state.sourceImgBlobUrl);
  const task = useCommonStore(state => state.task);
  const generating = useCommonStore(state => state.generating);
  const removeTipVisible = useCommonStore(state => state.removeTipVisible);

  return (
    <main
      className={styles["main"]}
    >
      <div
        className={styles["left_area"]}
      >
        {removeTipVisible && (
          <Suspense>
            <RemoveTip></RemoveTip>
          </Suspense>
        )}

       {task && task.status === TaskStatus.Success ? (
          <Result></Result>
        ) : (
          <>
            {sourceImgBlobUrl ? (
              <SourceImg
                src={sourceImgBlobUrl}
                alt=""
              ></SourceImg>
            ) : (
              <SampleVideo
              ></SampleVideo>
            )}
          </>
        )}

        {generating && (
          <Suspense>
            <Generating></Generating>
          </Suspense>
        )}

        <MainOperation></MainOperation>
      </div>

      <div
        className={styles["right_area"]}
      >
        <OverlayScrollbarsComponent
          className={styles["custom_scrollbar"]}
          style={{}}
          defer
        >
          <SourceImgUploader></SourceImgUploader>
          <ExpTempList></ExpTempList>
        </OverlayScrollbarsComponent>
        
        <div className={styles["generate_button_row"]}>
          <GenerateButton></GenerateButton>
        </div>
      </div>
    </main>
  )
}

export default Main;